import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TRPCProvider } from '@/providers/TRPCProvider';
import { Layout } from '@/components/layout/Layout';
import { LoginPage } from '@/pages/Login';
import { ForgotPasswordPage } from '@/pages/ForgotPassword';
import { ResetPasswordPage } from '@/pages/ResetPassword';
import { DashboardPage } from '@/pages/Dashboard';
import { FinanceiroPage } from '@/pages/financeiro';
import { EventosPage } from '@/pages/eventos';
import { EventoDetailPage } from '@/pages/eventos/EventoDetail';
import { EventoFormPage } from '@/pages/eventos/EventoForm';
import { PDVPage } from '@/pages/pdv';
import { EstoquePage } from '@/pages/estoque';
import { UsuariosPage } from '@/pages/usuarios';
import { CargosPage } from '@/pages/usuarios/cargos';
import { RelatoriosPage } from '@/pages/relatorios';
import { ConfiguracoesPage } from '@/pages/configuracoes';
import { PasseiosPage } from '@/pages/passeios';
import { CronometroPage } from '@/pages/cronometro';
import { AptidaoPage } from '@/pages/aptidao';
import { AptidaoResultadoPage } from '@/pages/aptidao/Resultado';
import { AptidaoResultadosPage } from '@/pages/aptidao/Resultados';

export function App() {
  return (
    <TRPCProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
          <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/financeiro" element={<FinanceiroPage />} />
            <Route path="/eventos" element={<EventosPage />} />
            <Route path="/eventos/novo" element={<EventoFormPage mode="create" />} />
            <Route path="/eventos/:id" element={<EventoDetailPage />} />
            <Route path="/eventos/:id/editar" element={<EventoFormPage mode="edit" />} />
            <Route path="/pdv" element={<PDVPage />} />
            <Route path="/estoque" element={<EstoquePage />} />
            <Route path="/usuarios" element={<UsuariosPage />} />
            <Route path="/usuarios/cargos" element={<CargosPage />} />
            <Route path="/relatorios" element={<RelatoriosPage />} />
            <Route path="/configuracoes" element={<ConfiguracoesPage />} />
            <Route path="/passeios" element={<PasseiosPage />} />
            <Route path="/cronometro" element={<CronometroPage />} />
            <Route path="/aptidao" element={<AptidaoPage />} />
            <Route path="/aptidao/resultado" element={<AptidaoResultadoPage />} />
            <Route path="/aptidao/resultados" element={<AptidaoResultadosPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </TRPCProvider>
  );
}
